export const analytics: Record<string, string> = {
  'Active departures': 'Départs actifs',
  'Active executions': 'Exécutions actives',
  'Alarm resolve': 'Résolution des alarmes',
  'Average time before review': 'Délai moyen avant examen',
  'Avg hrs / day block': 'Moy. d’heures / bloc journalier',
  'Capacity Graph': 'Graphique de capacité',
  'Coverage Horizon': 'Horizon de couverture',
  'Duty hours comparison over time': 'Comparaison des heures de service dans le temps',
  'Duty Mix': 'Répartition des services',
  'Duty outcomes': 'Résultats des services',
  'Escalated': 'Transmis',
  'Executed': 'Exécuté',
  'Flagged traces': 'Tracés signalés',
  'Guard Momentum': 'Dynamique des agents',
  'Hours': 'Heures',
  'Incident Overview': 'Vue d’ensemble des incidents',
  'Incidents': 'Incidents',
  'Live': 'En direct',
  'Live Watch': 'Surveillance en direct',
  'Live-tracked guards': 'Agents suivis en direct',
  'Low battery devices': 'Appareils à batterie faible',
  'Manual interventions': 'Interventions manuelles',
  'Missed duties': 'Services manqués',
  'Next 14d fill': 'Couverture des 14 prochains jours',
  'No guard activity landed in this range.':
    'Aucune activité d’agent n’a été enregistrée sur cette période.',
  'No recent execution or incident events landed in the last 48 hours.':
    'Aucun événement récent d’exécution ou d’incident n’a été enregistré au cours des dernières 48 heures.',
  'No uncovered or unpublished duties are visible in the next 14 days.':
    'Aucun service non couvert ou non publié n’est prévu au cours des 14 prochains jours.',
  'Open positions': 'Postes à pourvoir',
  'Operations Timeline': 'Chronologie des opérations',
  'Overrunning shifts': 'Vacations dépassant l’horaire',
  'Planned': 'Planifié',
  'Punctuality Trend': 'Évolution de la ponctualité',
  'Quality Metrics': 'Indicateurs de qualité',
  'Report close time': 'Délai de clôture des rapports',
  'Risk': 'Risque',
  'Roster Load Map': 'Carte de charge du planning',
  'Shift starts': 'Débuts de vacation',
  'Site Risk Board': 'Tableau des risques par site',
  'Sites currently active': 'Sites actuellement actifs',
  'Staffed': 'Pourvu',
  'Unpublished': 'Non publié',
  'Could not load analytics.': 'Impossible de charger les analyses.',
  'Analytics data is unavailable.': 'Les données d’analyse ne sont pas disponibles.',
  'Average planned guard-hours per weekday and four-hour block.':
    'Moyenne des heures-agent planifiées par jour de semaine et par bloc de quatre heures.',
  'Busiest Site': 'Site le plus chargé',
  'Checkpoint Proof': 'Preuve des points de contrôle',
  'Checkpoint completion': 'Achèvement des points de contrôle',
  'Critical': 'Critique',
  'Coverage exposure and execution drag for {site}.':
    'Exposition de couverture et retard d’exécution pour {site}.',
  'Coverage exposure and execution drag rolled up by site.':
    'Exposition de couverture et retard d’exécution regroupés par site.',
  'Current operational posture from executions and telemetry.':
    'Situation opérationnelle actuelle d’après les exécutions et la télémétrie.',
  'Duties Intelligence': 'Analyse des services',
  'Duty Coverage': 'Couverture des services',
  'Duty Delivery': 'Réalisation des services',
  'Duty completion': 'Achèvement des services',
  'Duty fill': 'Couverture des services',
  'Execution Starts': 'Débuts d’exécution',
  'Exposure': 'Exposition',
  'Fixed Post': 'Poste fixe',
  'Geofence compliance': 'Conformité géorepérage',
  'High': 'Élevé',
  'How the active incident queue is split right now.':
    'Répartition actuelle de la file d’incidents actifs.',
  'Incidents Open': 'Incidents ouverts',
  'Live Tracking': 'Suivi en direct',
  'Live duty coverage, execution quality, incident pressure, and roster risk built on the current duties-based model.':
    'Couverture des services en direct, qualité d’exécution, pression des incidents et risque de planning fondés sur le modèle actuel par services.',
  'Next Gap': 'Prochaine lacune',
  'No activity': 'Aucune activité',
  'No gaps queued': 'Aucune lacune en attente',
  'No planned duty hours in this range.':
    'Aucune heure de service planifiée sur cette période.',
  'No recent execution activity to score.':
    'Aucune activité d’exécution récente à évaluer.',
  'No site risk signals are active.': 'Aucun signal de risque site n’est actif.',
  'No standout': 'Aucun agent notable',
  'Operational analytics for {site} within {company}, built on the current duties-based model.':
    'Analyses opérationnelles de {site} au sein de {company}, fondées sur le modèle actuel par services.',
  'Planned, staffed, and actually executed duty hours across the selected window.':
    'Heures de service planifiées, pourvues et réellement exécutées sur la période sélectionnée.',
  'Publication': 'Publication',
  'Punctuality': 'Ponctualité',
  'Recent execution, incident, and intervention signals.':
    'Signaux récents d’exécution, d’incident et d’intervention.',
  'Refreshing': 'Actualisation',
  'Report ownership': 'Attribution des rapports',
  'Selected Site': 'Site sélectionné',
  'Selected site': 'Site sélectionné',
  'Site Focus': 'Focus site',
  'Stable': 'Stable',
  'Start rate': 'Taux de démarrage',
  'Starts and duty outcomes day by day.':
    'Démarrages et résultats des services jour par jour.',
  'The next 14 days are fully staffed and published.':
    'Les 14 prochains jours sont entièrement pourvus et publiés.',
  'The next uncovered or unpublished duties that need attention.':
    'Les prochains services non couverts ou non publiés à traiter.',
  'The operating ratios worth watching every day.':
    'Les ratios opérationnels à surveiller chaque jour.',
  'Where planned hours are landing and how well each duty type is staffed.':
    'Répartition des heures planifiées et niveau de couverture de chaque type de service.',
  'Watch': 'À surveiller',
  'Who is carrying the most operational load and with what reliability.':
    'Agents qui portent la plus forte charge opérationnelle et leur fiabilité.',
  '{assigned}/{required} filled': '{assigned}/{required} pourvu',
  '{battery} low battery - {traces} flagged traces':
    '{battery} batterie faible - {traces} tracés signalés',
  '{completed} completed vs {lost} lost': '{completed} terminés contre {lost} perdus',
  '{completed}/{planned} checkpoints completed':
    '{completed}/{planned} points de contrôle terminés',
  '{completed}/{planned} planned checkpoints hit':
    '{completed}/{planned} points de contrôle planifiés validés',
  '{count} duties missed or skipped': '{count} services manqués ou ignorés',
  '{count} escalated reports still open':
    '{count} rapports transmis encore ouverts',
  '{count} flagged location samples':
    '{count} échantillons de position signalés',
  '{count} late starts in window': '{count} démarrages tardifs sur la période',
  '{count} late starts recorded': '{count} démarrages tardifs enregistrés',
  '{count} live items': '{count} éléments en direct',
  '{count} open': '{count} ouverts',
  '{count} open positions in the next 14 days':
    '{count} postes à pourvoir dans les 14 prochains jours',
  '{count} reports still open': '{count} rapports encore ouverts',
  '{count} upcoming positions still exposed':
    '{count} postes à venir encore exposés',
  '{covered} of {planned} covered': '{covered} sur {planned} couverts',
  '{executed} executed of {planned} planned':
    '{executed} exécutées sur {planned} planifiées',
  '{guards} live-tracked guards across {sites} active sites':
    '{guards} agents suivis en direct sur {sites} sites actifs',
  '{guards} live-tracked guards on {site}':
    '{guards} agents suivis en direct sur {site}',
  '{hours} executed - {punctuality} punctual - {delivery} delivery':
    '{hours} exécutées - {punctuality} ponctuelles - {delivery} réalisées',
  '{hours} executed in the selected window':
    '{hours} exécutées sur la période sélectionnée',
  '{hours} executed in window': '{hours} exécutées sur la période',
  '{incidents} live incidents - {fill} next-14d fill':
    '{incidents} incidents en direct - {fill} couverture des 14 prochains jours',
  '{punctuality} punctual - {completion} duty completion':
    '{punctuality} ponctuels - {completion} d’achèvement des services',
  '{reports} open reports and {alarms} active alarms':
    '{reports} rapports ouverts et {alarms} alarmes actives',
  '{site} - {count} open at {time}': '{site} - {count} ouverts à {time}',
  '{staffed} staffed of {planned} planned':
    '{staffed} pourvues sur {planned} planifiées',
  '{started}/{due} due shifts started':
    '{started}/{due} vacations dues démarrées',
  '{started}/{due} published shifts started':
    '{started}/{due} vacations publiées démarrées',
  '{time} average alarm resolve time':
    '{time} de délai moyen de résolution des alarmes',
  'Updated {time}': 'Mis à jour à {time}',
};
